module.exports = __webpack_public_path__ + "static/media/sidebar-5.8336c4e9.jpg";